// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file partner_service.proto (package qb.smg, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Error, PartnerUserIdentifier, Session, User } from "./smg_service_pb";
import { file_smg_service } from "./smg_service_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file partner_service.proto.
 */
export const file_partner_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_smg_service]);

/**
 * *
 * Request message for SimulateUserTemporary method.
 * Contains the information needed to authenticate a user and assign them to a specific station.
 *
 * @generated from message qb.smg.SimulateUserTemporaryRequest
 */
export type SimulateUserTemporaryRequest = Message<"qb.smg.SimulateUserTemporaryRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The unique identifier of the station where the user will become the active player.
   *
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.SimulateUserTemporaryRequest.
 * Use `create(SimulateUserTemporaryRequestSchema)` to create a new message.
 */
export const SimulateUserTemporaryRequestSchema: GenMessage<SimulateUserTemporaryRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 0);

/**
 * *
 * Response message for SimulateUserTemporary method.
 * Indicates whether the operation was successful and provides error details if it failed.
 *
 * @generated from message qb.smg.SimulateUserTemporaryReply
 */
export type SimulateUserTemporaryReply = Message<"qb.smg.SimulateUserTemporaryReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * Indicates whether the user was successfully made the active player at the specified station.
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.SimulateUserTemporaryReply.
 * Use `create(SimulateUserTemporaryReplySchema)` to create a new message.
 */
export const SimulateUserTemporaryReplySchema: GenMessage<SimulateUserTemporaryReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 1);

/**
 * *
 * Request message for SimulateUserViaBluetooth method.
 * Contains the information needed to authenticate a user and assign them to a station via Bluetooth.
 *
 * @generated from message qb.smg.SimulateUserViaBluetoothRequest
 */
export type SimulateUserViaBluetoothRequest = Message<"qb.smg.SimulateUserViaBluetoothRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The Bluetooth service UUID that identifies the target station.
   *
   * @generated from field: string serviceUUID = 2;
   */
  serviceUUID: string;
};

/**
 * Describes the message qb.smg.SimulateUserViaBluetoothRequest.
 * Use `create(SimulateUserViaBluetoothRequestSchema)` to create a new message.
 */
export const SimulateUserViaBluetoothRequestSchema: GenMessage<SimulateUserViaBluetoothRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 2);

/**
 * *
 * Response message for SimulateUserViaBluetooth method.
 * Indicates whether the operation was successful and provides error details if it failed.
 *
 * @generated from message qb.smg.SimulateUserViaBluetoothReply
 */
export type SimulateUserViaBluetoothReply = Message<"qb.smg.SimulateUserViaBluetoothReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * Indicates whether the user was successfully made the active player at the station identified by the Bluetooth service UUID.
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.SimulateUserViaBluetoothReply.
 * Use `create(SimulateUserViaBluetoothReplySchema)` to create a new message.
 */
export const SimulateUserViaBluetoothReplySchema: GenMessage<SimulateUserViaBluetoothReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 3);

/**
 * *
 * Request message for SimulateUserViaQrCode method.
 * Contains the information needed to authenticate a user and assign them to a station via QR code.
 *
 * @generated from message qb.smg.SimulateUserViaQrCodeRequest
 */
export type SimulateUserViaQrCodeRequest = Message<"qb.smg.SimulateUserViaQrCodeRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The QR code that identifies the target station.
   *
   * @generated from field: string qrCode = 2;
   */
  qrCode: string;
};

/**
 * Describes the message qb.smg.SimulateUserViaQrCodeRequest.
 * Use `create(SimulateUserViaQrCodeRequestSchema)` to create a new message.
 */
export const SimulateUserViaQrCodeRequestSchema: GenMessage<SimulateUserViaQrCodeRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 4);

/**
 * *
 * Response message for SimulateUserViaQrCode method.
 * Indicates whether the operation was successful and provides error details if it failed.
 *
 * @generated from message qb.smg.SimulateUserViaQrCodeReply
 */
export type SimulateUserViaQrCodeReply = Message<"qb.smg.SimulateUserViaQrCodeReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * Indicates whether the user was successfully made the active player at the station identified by the QR code.
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.SimulateUserViaQrCodeReply.
 * Use `create(SimulateUserViaQrCodeReplySchema)` to create a new message.
 */
export const SimulateUserViaQrCodeReplySchema: GenMessage<SimulateUserViaQrCodeReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 5);

/**
 * @generated from message qb.smg.FullSwingTokenLoginRequest
 */
export type FullSwingTokenLoginRequest = Message<"qb.smg.FullSwingTokenLoginRequest"> & {
  /**
   * required
   *
   * @generated from field: string id_token = 2;
   */
  idToken: string;

  /**
   * optional
   *
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingTokenLoginRequest.
 * Use `create(FullSwingTokenLoginRequestSchema)` to create a new message.
 */
export const FullSwingTokenLoginRequestSchema: GenMessage<FullSwingTokenLoginRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 6);

/**
 * @generated from message qb.smg.FullSwingTokenLoginReply
 */
export type FullSwingTokenLoginReply = Message<"qb.smg.FullSwingTokenLoginReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;

  /**
   * Details of this session (including UserId).
   *
   * @generated from field: qb.smg.Session session = 3;
   */
  session?: Session;

  /**
   * @generated from field: qb.smg.User user = 4;
   */
  user?: User;
};

/**
 * Describes the message qb.smg.FullSwingTokenLoginReply.
 * Use `create(FullSwingTokenLoginReplySchema)` to create a new message.
 */
export const FullSwingTokenLoginReplySchema: GenMessage<FullSwingTokenLoginReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 7);

/**
 * @generated from message qb.smg.FullSwingCancelRegisterRequest
 */
export type FullSwingCancelRegisterRequest = Message<"qb.smg.FullSwingCancelRegisterRequest"> & {
  /**
   * evenplay token
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.FullSwingCancelRegisterRequest.
 * Use `create(FullSwingCancelRegisterRequestSchema)` to create a new message.
 */
export const FullSwingCancelRegisterRequestSchema: GenMessage<FullSwingCancelRegisterRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 8);

/**
 * @generated from message qb.smg.FullSwingCancelRegisterReply
 */
export type FullSwingCancelRegisterReply = Message<"qb.smg.FullSwingCancelRegisterReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingCancelRegisterReply.
 * Use `create(FullSwingCancelRegisterReplySchema)` to create a new message.
 */
export const FullSwingCancelRegisterReplySchema: GenMessage<FullSwingCancelRegisterReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 9);

/**
 * @generated from message qb.smg.FullSwingCheckSimulatorIdentifierRequest
 */
export type FullSwingCheckSimulatorIdentifierRequest = Message<"qb.smg.FullSwingCheckSimulatorIdentifierRequest"> & {
  /**
   * @generated from field: string simulator_identifier = 1;
   */
  simulatorIdentifier: string;
};

/**
 * Describes the message qb.smg.FullSwingCheckSimulatorIdentifierRequest.
 * Use `create(FullSwingCheckSimulatorIdentifierRequestSchema)` to create a new message.
 */
export const FullSwingCheckSimulatorIdentifierRequestSchema: GenMessage<FullSwingCheckSimulatorIdentifierRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 10);

/**
 * @generated from message qb.smg.FullSwingCheckSimulatorIdentifierReply
 */
export type FullSwingCheckSimulatorIdentifierReply = Message<"qb.smg.FullSwingCheckSimulatorIdentifierReply"> & {
  /**
   * @generated from field: qb.smg.SimulatorMoneyCapability simulator_money_capability = 1;
   */
  simulatorMoneyCapability: SimulatorMoneyCapability;
};

/**
 * Describes the message qb.smg.FullSwingCheckSimulatorIdentifierReply.
 * Use `create(FullSwingCheckSimulatorIdentifierReplySchema)` to create a new message.
 */
export const FullSwingCheckSimulatorIdentifierReplySchema: GenMessage<FullSwingCheckSimulatorIdentifierReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 11);

/**
 * @generated from message qb.smg.GetSimulatorDeviceLocationRequest
 */
export type GetSimulatorDeviceLocationRequest = Message<"qb.smg.GetSimulatorDeviceLocationRequest"> & {
  /**
   * @generated from field: string simulator_identifier = 1;
   */
  simulatorIdentifier: string;
};

/**
 * Describes the message qb.smg.GetSimulatorDeviceLocationRequest.
 * Use `create(GetSimulatorDeviceLocationRequestSchema)` to create a new message.
 */
export const GetSimulatorDeviceLocationRequestSchema: GenMessage<GetSimulatorDeviceLocationRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 12);

/**
 * GetSimulatorDeviceLocationReply carries the raw, partner-supplied device
 * location. When valid=false (unknown / unparseable identifier) all location
 * fields are empty/zero and the caller treats the jurisdiction as unresolved.
 *
 * @generated from message qb.smg.GetSimulatorDeviceLocationReply
 */
export type GetSimulatorDeviceLocationReply = Message<"qb.smg.GetSimulatorDeviceLocationReply"> & {
  /**
   * mirrors the partner-source validIdentifier bool; false = unknown device.
   *
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: double latitude = 2;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 3;
   */
  longitude: number;

  /**
   * street line, raw.
   *
   * @generated from field: string address = 4;
   */
  address: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * abbreviated where partner-service could abbreviate.
   *
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * abbreviated where partner-service could abbreviate.
   *
   * @generated from field: string country_code = 7;
   */
  countryCode: string;

  /**
   * @generated from field: string zip_code = 8;
   */
  zipCode: string;
};

/**
 * Describes the message qb.smg.GetSimulatorDeviceLocationReply.
 * Use `create(GetSimulatorDeviceLocationReplySchema)` to create a new message.
 */
export const GetSimulatorDeviceLocationReplySchema: GenMessage<GetSimulatorDeviceLocationReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 13);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationDetailsStreamRequest
 */
export type FullSwingSessionParticipationDetailsStreamRequest = Message<"qb.smg.FullSwingSessionParticipationDetailsStreamRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationDetailsStreamRequest.
 * Use `create(FullSwingSessionParticipationDetailsStreamRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationDetailsStreamRequestSchema: GenMessage<FullSwingSessionParticipationDetailsStreamRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 14);

/**
 * @generated from message qb.smg.FullSwingSessionParticipant
 */
export type FullSwingSessionParticipant = Message<"qb.smg.FullSwingSessionParticipant"> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: qb.smg.PartnerUserIdentifier partner_user_identifier = 2;
   */
  partnerUserIdentifier?: PartnerUserIdentifier;

  /**
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * @generated from field: bool has_accepted_bet = 7;
   */
  hasAcceptedBet: boolean;

  /**
   * only 1 user per session/station will be active
   *
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * has no active bet for last X minutes
   *
   * @generated from field: bool is_idle = 9;
   */
  isIdle: boolean;

  /**
   * true if this player has mobile confirmation bypass enabled
   *
   * @generated from field: bool account_security_bypass_enabled = 10;
   */
  accountSecurityBypassEnabled: boolean;

  /**
   * Target distance in yards for the participant's currently accepted bet.
   * Snapshotted onto the participant row when the bet is accepted (engine
   * publishes bet_accepted_partner) and cleared when the bet leaves the
   * active-target state (engine publishes bet_resolved_partner on refund;
   * core publishes bet_resolved_partner on hit-resolved). 0 when the bet
   * has no target or when no bet is currently accepted (also implies
   * has_accepted_bet=false). The round-robin "Next Up" UI uses this to
   * preview each upcoming player's target without a separate per-player
   * bet lookup.
   *
   * @generated from field: int64 target_distance_yards = 11;
   */
  targetDistanceYards: bigint;

  /**
   * Previewed target distance in yards for the participant's currently-being-played
   * (or about-to-be-played) bet. Set when the engine fills a bet
   * (publishes bet_filled_partner), and OVERWRITTEN on the next
   * bet_filled_partner. NOT cleared on accept, cancel, or expire —
   * consumers MUST gate display on has_accepted_bet (when true, render
   * target_distance_yards as the canonical target; when false, render
   * previewed_target_distance_yards as the upcoming preview). 0 only when
   * no bet has ever been filled for this participant in this session.
   * Distinct from target_distance_yards (field 11): these are sibling
   * fields, not overloads — target_distance_yards is the snapshotted
   * accepted target (cleared on resolve), previewed_target_distance_yards
   * is the always-on most-recent-fill mirror.
   *
   * @generated from field: int64 previewed_target_distance_yards = 12;
   */
  previewedTargetDistanceYards: bigint;

  /**
   * Target distance in yards for the SHOT AFTER previewed_target_distance_yards
   * (i.e., the next bet's target after the currently-previewed bet). Sourced
   * from Paylines' next_shot_target_yards at fill time. Same lifecycle as
   * previewed_target_distance_yards: set on bet_filled_partner, overwritten
   * on the next fill, NOT cleared on accept/cancel/expire. 0 only when no
   * bet has been filled in this session yet, or when Paylines could not
   * compute a next-shot prediction (transient unavailability).
   *
   * @generated from field: int64 previewed_next_target_yards = 13;
   */
  previewedNextTargetYards: bigint;

  /**
   * Distance in yards of the participant's previously-resolved bet. Set
   * when the bet_resolved_partner consumer processes a resolution event,
   * atomically alongside clearing target_distance_yards (preserving SMG-2564's
   * "0 after resolve" invariant on field 11). Overwritten on the next
   * resolution event — the [previous, current, next] window slides forward.
   * 0 only when no bet has yet resolved in this session.
   *
   * @generated from field: int64 previous_target_distance_yards = 14;
   */
  previousTargetDistanceYards: bigint;

  /**
   * Outcome of the previously-resolved bet, sourced from the bet_resolved_partner
   * event's outcome field. UNSPECIFIED (0) when no previous bet exists yet.
   * Drives the round-robin UI's color hint on the previous-shot slot:
   * WON=green, LOST=red, CANCELLED/EXPIRED=neutral (typically not rendered).
   *
   * @generated from field: qb.smg.BetOutcome previous_target_outcome = 15;
   */
  previousTargetOutcome: BetOutcome;

  /**
   * Per-participant "Confirm Before Each Turn" flag. Mirrors the
   * round_robin_confirmation_required DB column directly (no negation):
   * true means "this player wants the per-turn confirmation modal";
   * false means "auto-activate without modal". The mode-agnostic name
   * reflects that the gate now covers both ROTATION (rotation auto-advance)
   * and OPEN (kiosk-driven SelectPlayer) entry points. The legacy field
   * `account_security_bypass_enabled` (10) carries the inverted semantics
   * for backwards compatibility with already-deployed mobile clients;
   * new consumers SHOULD prefer this field.
   *
   * @generated from field: bool confirm_before_each_turn = 16;
   */
  confirmBeforeEachTurn: boolean;

  /**
   * Player handedness ("right" or "left"), sourced from User.handedness at
   * check-in (GetUserReply.user.handedness) and persisted on the participant
   * row at join time. Full Swing simulators are physical machines that
   * auto-configure tee position, launch-monitor angle, and camera
   * orientation per the upcoming player's handedness. Empty string when the
   * user record carried no handedness, or for participant rows created
   * before this field was wired (the source column is nullable TEXT).
   * Field number 17 (not the ticket's proposed 10/11 — those slots are
   * already occupied by account_security_bypass_enabled / target_distance_yards).
   *
   * @generated from field: string handedness = 17;
   */
  handedness: string;

  /**
   * 1-based position of this participant in join order (earliest join = 1).
   * Producers sort participants by join_time ascending before assigning
   * positions, so the value is stable across stream updates as long as the
   * roster is unchanged. For ROTATION mode the simulator uses this to render
   * the full ordered queue ("you are batting 3rd"); RoundRobinState (SMG-2385)
   * only carries current+next, not the complete ordered list. 0 is never
   * emitted for a present participant (positions start at 1).
   *
   * @generated from field: int32 rotation_position = 18;
   */
  rotationPosition: number;

  /**
   * Monotonic identity of this active-player epoch, copied from Bay's
   * SessionState.active_generation. Non-zero only for the participant whose
   * is_active flag is true. When arming a shot clock, the simulator must
   * capture this value together with user_id and echo that exact pair in
   * FullSwingSessionParticipationDeactivationRequest; it must not read the
   * latest frame when an older clock expires. This prevents an old clock event
   * from deactivating a newer turn of the same user.
   *
   * @generated from field: int64 activation_generation = 19;
   */
  activationGeneration: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipant.
 * Use `create(FullSwingSessionParticipantSchema)` to create a new message.
 */
export const FullSwingSessionParticipantSchema: GenMessage<FullSwingSessionParticipant> = /*@__PURE__*/
  messageDesc(file_partner_service, 15);

/**
 * @generated from message qb.smg.FullSwingSessionPlayerSelectConfirmation
 */
export type FullSwingSessionPlayerSelectConfirmation = Message<"qb.smg.FullSwingSessionPlayerSelectConfirmation"> & {
  /**
   * last selected user_id. int64 to match every other user_id field in this
   * package (and smg_service.proto / station_state_computer.proto); int32 was
   * an oversight (SMG-2737). int32->int64 on the same tag is varint
   * wire-compatible, so no transition field is required.
   *
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * the status of last select confirmation
   *
   * @generated from field: qb.smg.FullSwingSessionPlayerSelectConfirmation.Status status = 2;
   */
  status: FullSwingSessionPlayerSelectConfirmation_Status;

  /**
   * timestamp of when last status change happened on confirmation
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSessionPlayerSelectConfirmation.
 * Use `create(FullSwingSessionPlayerSelectConfirmationSchema)` to create a new message.
 */
export const FullSwingSessionPlayerSelectConfirmationSchema: GenMessage<FullSwingSessionPlayerSelectConfirmation> = /*@__PURE__*/
  messageDesc(file_partner_service, 16);

/**
 * @generated from enum qb.smg.FullSwingSessionPlayerSelectConfirmation.Status
 */
export enum FullSwingSessionPlayerSelectConfirmation_Status {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: TIMEOUT = 3;
   */
  TIMEOUT = 3,
}

/**
 * Describes the enum qb.smg.FullSwingSessionPlayerSelectConfirmation.Status.
 */
export const FullSwingSessionPlayerSelectConfirmation_StatusSchema: GenEnum<FullSwingSessionPlayerSelectConfirmation_Status> = /*@__PURE__*/
  enumDesc(file_partner_service, 16, 0);

/**
 * RoundRobinState carries the current round-robin turn state to stream consumers.
 * Player IDs (player_order) are repeated int64, matching the participant model
 * used throughout partner-service.
 *
 * @generated from message qb.smg.RoundRobinState
 */
export type RoundRobinState = Message<"qb.smg.RoundRobinState"> & {
  /**
   * @generated from field: bool is_enabled = 1;
   */
  isEnabled: boolean;

  /**
   * @generated from field: int64 current_player_user_id = 2;
   */
  currentPlayerUserId: bigint;

  /**
   * @generated from field: int64 next_player_user_id = 3;
   */
  nextPlayerUserId: bigint;

  /**
   * @generated from field: int32 shots_taken = 4;
   */
  shotsTaken: number;

  /**
   * @generated from field: int32 shots_remaining = 5;
   */
  shotsRemaining: number;

  /**
   * @generated from field: int32 shots_per_turn = 6;
   */
  shotsPerTurn: number;

  /**
   * @generated from field: bool turn_complete = 7;
   */
  turnComplete: boolean;

  /**
   * @generated from field: repeated int64 player_order = 8;
   */
  playerOrder: bigint[];

  /**
   * Per-slot usernames, parallel to player_order (1:1 by index). When a
   * user_id in player_order has no matching participant row at message
   * build time (race: removed mid-stream between SSC AddPlayer and
   * partner-service emit), the corresponding slot is the empty string.
   * Consumers MUST treat empty-string as "fall back to formatted player
   * ID". Producers MUST emit len(usernames) == len(player_order) — never
   * a partial slice. Pre-existing consumers (built before this field was
   * added) silently ignore it via the proto3 default-unmarshal contract.
   *
   * @generated from field: repeated string usernames = 9;
   */
  usernames: string[];
};

/**
 * Describes the message qb.smg.RoundRobinState.
 * Use `create(RoundRobinStateSchema)` to create a new message.
 */
export const RoundRobinStateSchema: GenMessage<RoundRobinState> = /*@__PURE__*/
  messageDesc(file_partner_service, 17);

/**
 * KioskParticipant is the lean per-player roster projection the kiosk UI
 * (PartnerKioskUpdatesStream) needs to render the participant list. It is
 * intentionally a subset of FullSwingSessionParticipant (identity + active
 * flag only) so the kiosk does not need a second subscription to the
 * simulator-token-gated FullSwingSessionParticipationDetailsStream — that
 * stream requires a signed HMAC simulator token the kiosk cannot mint.
 * is_active marks the single currently-active player (at most one per
 * session); all other rows carry is_active=false.
 *
 * @generated from message qb.smg.KioskParticipant
 */
export type KioskParticipant = Message<"qb.smg.KioskParticipant"> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bool is_active = 3;
   */
  isActive: boolean;
};

/**
 * Describes the message qb.smg.KioskParticipant.
 * Use `create(KioskParticipantSchema)` to create a new message.
 */
export const KioskParticipantSchema: GenMessage<KioskParticipant> = /*@__PURE__*/
  messageDesc(file_partner_service, 18);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationDetailsStreamUpdate
 */
export type FullSwingSessionParticipationDetailsStreamUpdate = Message<"qb.smg.FullSwingSessionParticipationDetailsStreamUpdate"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: repeated qb.smg.FullSwingSessionParticipant participants = 2;
   */
  participants: FullSwingSessionParticipant[];

  /**
   * @generated from field: qb.smg.FullSwingSessionPlayerSelectConfirmation player_select_confirmation = 3;
   */
  playerSelectConfirmation?: FullSwingSessionPlayerSelectConfirmation;

  /**
   * Current session play mode (reserved for future use)
   *
   * @generated from field: qb.smg.SessionPlayMode play_mode = 4;
   */
  playMode: SessionPlayMode;

  /**
   * @generated from field: qb.smg.RoundRobinState round_robin_state = 5;
   */
  roundRobinState?: RoundRobinState;

  /**
   * True when the session has reached its configured participant cap, so the
   * simulator hides/disables the "scan to join" QR display. Mirrors the same
   * capacity check the kiosk stream already surfaces via
   * PartnerKioskUpdate.UserSessionUpdateData.is_session_full. A configured
   * max of 0 means "unlimited" and is_session_full is always false.
   *
   * @generated from field: bool is_session_full = 6;
   */
  isSessionFull: boolean;

  /**
   * Configured maximum participant count for the session, from
   * FsStationSession.ConfiguredMaxAllowedParticipantCount. Enables the
   * simulator's "X of Y players joined" display. 0 means unlimited (no cap
   * configured).
   *
   * @generated from field: int32 max_allowed_participant_count = 7;
   */
  maxAllowedParticipantCount: number;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationDetailsStreamUpdate.
 * Use `create(FullSwingSessionParticipationDetailsStreamUpdateSchema)` to create a new message.
 */
export const FullSwingSessionParticipationDetailsStreamUpdateSchema: GenMessage<FullSwingSessionParticipationDetailsStreamUpdate> = /*@__PURE__*/
  messageDesc(file_partner_service, 19);

/**
 * @generated from message qb.smg.FullSwingSessionConfigureRequest
 */
export type FullSwingSessionConfigureRequest = Message<"qb.smg.FullSwingSessionConfigureRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * config
   *
   * @generated from field: int32 max_allowed_participant_count = 4;
   */
  maxAllowedParticipantCount: number;

  /**
   * Determines turn management (solo/open/rotation)
   *
   * @generated from field: qb.smg.SessionPlayMode play_mode = 5;
   */
  playMode: SessionPlayMode;

  /**
   * Number of shots per player turn; 0 means default (1)
   *
   * @generated from field: int32 shots_per_turn = 6;
   */
  shotsPerTurn: number;

  /**
   * Opt out of round-robin rotation for this session; persisted on configure, read by orchestration RPCs.
   *
   * @generated from field: bool disable_round_robin = 7;
   */
  disableRoundRobin: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionConfigureRequest.
 * Use `create(FullSwingSessionConfigureRequestSchema)` to create a new message.
 */
export const FullSwingSessionConfigureRequestSchema: GenMessage<FullSwingSessionConfigureRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 20);

/**
 * @generated from message qb.smg.FullSwingSessionConfigureReply
 */
export type FullSwingSessionConfigureReply = Message<"qb.smg.FullSwingSessionConfigureReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionConfigureReply.
 * Use `create(FullSwingSessionConfigureReplySchema)` to create a new message.
 */
export const FullSwingSessionConfigureReplySchema: GenMessage<FullSwingSessionConfigureReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 21);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationSelectPlayerRequest
 */
export type FullSwingSessionParticipationSelectPlayerRequest = Message<"qb.smg.FullSwingSessionParticipationSelectPlayerRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int32 user_id = 3;
   */
  userId: number;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationSelectPlayerRequest.
 * Use `create(FullSwingSessionParticipationSelectPlayerRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationSelectPlayerRequestSchema: GenMessage<FullSwingSessionParticipationSelectPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 22);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationSelectPlayerReply
 */
export type FullSwingSessionParticipationSelectPlayerReply = Message<"qb.smg.FullSwingSessionParticipationSelectPlayerReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationSelectPlayerReply.
 * Use `create(FullSwingSessionParticipationSelectPlayerReplySchema)` to create a new message.
 */
export const FullSwingSessionParticipationSelectPlayerReplySchema: GenMessage<FullSwingSessionParticipationSelectPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 23);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationRemovePlayerRequest
 */
export type FullSwingSessionParticipationRemovePlayerRequest = Message<"qb.smg.FullSwingSessionParticipationRemovePlayerRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int32 user_id = 3;
   */
  userId: number;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationRemovePlayerRequest.
 * Use `create(FullSwingSessionParticipationRemovePlayerRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationRemovePlayerRequestSchema: GenMessage<FullSwingSessionParticipationRemovePlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 24);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationRemovePlayerReply
 */
export type FullSwingSessionParticipationRemovePlayerReply = Message<"qb.smg.FullSwingSessionParticipationRemovePlayerReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationRemovePlayerReply.
 * Use `create(FullSwingSessionParticipationRemovePlayerReplySchema)` to create a new message.
 */
export const FullSwingSessionParticipationRemovePlayerReplySchema: GenMessage<FullSwingSessionParticipationRemovePlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 25);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationDeactivationRequest
 */
export type FullSwingSessionParticipationDeactivationRequest = Message<"qb.smg.FullSwingSessionParticipationDeactivationRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int32 user_id = 3;
   */
  userId: number;

  /**
   * Active epoch captured from the FullSwingSessionParticipant frame that
   * armed this exact shot clock. A positive value enables Bay's fenced timeout
   * command. Proto3 zero is backward-compatible and keeps the pre-SMG-4001
   * Bay+SSC bridge until the simulator and core read route are upgraded. The
   * client must not replace a captured positive value with a newer frame's
   * generation when the old clock expires.
   *
   * @generated from field: int64 expected_activation_generation = 4;
   */
  expectedActivationGeneration: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationDeactivationRequest.
 * Use `create(FullSwingSessionParticipationDeactivationRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationDeactivationRequestSchema: GenMessage<FullSwingSessionParticipationDeactivationRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 26);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationDeactivationReply
 */
export type FullSwingSessionParticipationDeactivationReply = Message<"qb.smg.FullSwingSessionParticipationDeactivationReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully deactivated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationDeactivationReply.
 * Use `create(FullSwingSessionParticipationDeactivationReplySchema)` to create a new message.
 */
export const FullSwingSessionParticipationDeactivationReplySchema: GenMessage<FullSwingSessionParticipationDeactivationReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 27);

/**
 * @generated from message qb.smg.PartnerKioskUpdatesStreamRequest
 */
export type PartnerKioskUpdatesStreamRequest = Message<"qb.smg.PartnerKioskUpdatesStreamRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.PartnerKioskUpdatesStreamRequest.
 * Use `create(PartnerKioskUpdatesStreamRequestSchema)` to create a new message.
 */
export const PartnerKioskUpdatesStreamRequestSchema: GenMessage<PartnerKioskUpdatesStreamRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 28);

/**
 * @generated from message qb.smg.PartnerKioskUpdate
 */
export type PartnerKioskUpdate = Message<"qb.smg.PartnerKioskUpdate"> & {
  /**
   * @generated from field: qb.smg.PartnerKioskUpdate.UpdateKind update = 1;
   */
  update: PartnerKioskUpdate_UpdateKind;

  /**
   * @generated from oneof qb.smg.PartnerKioskUpdate.data
   */
  data: {
    /**
     * @generated from field: qb.smg.PartnerKioskUpdate.UserSessionParticipationConfirmationData userSessionParticipationConfirmationData = 2;
     */
    value: PartnerKioskUpdate_UserSessionParticipationConfirmationData;
    case: "userSessionParticipationConfirmationData";
  } | {
    /**
     * @generated from field: qb.smg.PartnerKioskUpdate.UserSessionUpdateData userSessionUpdateData = 4;
     */
    value: PartnerKioskUpdate_UserSessionUpdateData;
    case: "userSessionUpdateData";
  } | {
    /**
     * @generated from field: qb.smg.PartnerKioskUpdate.UserSessionPendingConfirmationRemovalData userSessionPendingConfirmationRemovalData = 5;
     */
    value: PartnerKioskUpdate_UserSessionPendingConfirmationRemovalData;
    case: "userSessionPendingConfirmationRemovalData";
  } | { case: undefined; value?: undefined };

  /**
   * timestamp of when event produced
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;
};

/**
 * Describes the message qb.smg.PartnerKioskUpdate.
 * Use `create(PartnerKioskUpdateSchema)` to create a new message.
 */
export const PartnerKioskUpdateSchema: GenMessage<PartnerKioskUpdate> = /*@__PURE__*/
  messageDesc(file_partner_service, 29);

/**
 * @generated from message qb.smg.PartnerKioskUpdate.UserSessionParticipationConfirmationData
 */
export type PartnerKioskUpdate_UserSessionParticipationConfirmationData = Message<"qb.smg.PartnerKioskUpdate.UserSessionParticipationConfirmationData"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.PartnerKioskUpdate.UserSessionParticipationConfirmationData.
 * Use `create(PartnerKioskUpdate_UserSessionParticipationConfirmationDataSchema)` to create a new message.
 */
export const PartnerKioskUpdate_UserSessionParticipationConfirmationDataSchema: GenMessage<PartnerKioskUpdate_UserSessionParticipationConfirmationData> = /*@__PURE__*/
  messageDesc(file_partner_service, 29, 0);

/**
 * @generated from message qb.smg.PartnerKioskUpdate.UserSessionPendingConfirmationRemovalData
 */
export type PartnerKioskUpdate_UserSessionPendingConfirmationRemovalData = Message<"qb.smg.PartnerKioskUpdate.UserSessionPendingConfirmationRemovalData"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int32 user_id = 2;
   */
  userId: number;
};

/**
 * Describes the message qb.smg.PartnerKioskUpdate.UserSessionPendingConfirmationRemovalData.
 * Use `create(PartnerKioskUpdate_UserSessionPendingConfirmationRemovalDataSchema)` to create a new message.
 */
export const PartnerKioskUpdate_UserSessionPendingConfirmationRemovalDataSchema: GenMessage<PartnerKioskUpdate_UserSessionPendingConfirmationRemovalData> = /*@__PURE__*/
  messageDesc(file_partner_service, 29, 1);

/**
 * @generated from message qb.smg.PartnerKioskUpdate.UserSessionUpdateData
 */
export type PartnerKioskUpdate_UserSessionUpdateData = Message<"qb.smg.PartnerKioskUpdate.UserSessionUpdateData"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: qb.smg.PartnerKioskUpdate.UserSessionUpdateData.UserSessionState user_session_state = 2;
   */
  userSessionState: PartnerKioskUpdate_UserSessionUpdateData_UserSessionState;

  /**
   * @generated from field: string session_current_active_player_username = 3;
   */
  sessionCurrentActivePlayerUsername: string;

  /**
   * @generated from field: bool is_session_full = 4;
   */
  isSessionFull: boolean;

  /**
   * true if the streaming player has mobile confirmation bypass enabled
   *
   * @generated from field: bool account_security_bypass_enabled = 5;
   */
  accountSecurityBypassEnabled: boolean;

  /**
   * @generated from field: qb.smg.RoundRobinState round_robin_state = 7;
   */
  roundRobinState?: RoundRobinState;

  /**
   * Per-mobile-user bet snapshot, mirrored from the participant row so
   * mobile clients don't need a second subscription to
   * FullSwingSessionParticipationDetailsStream. Lifecycle matches the
   * siblings on FullSwingSessionParticipant — these fields are
   * overwrite-only (set on bet_filled_partner / bet_accepted_partner /
   * bet_resolved_partner, never cleared on accept/cancel/expire), and the
   * consumer disambiguates "currently accepted" from "filled-but-not-yet-
   * accepted" via has_accepted_bet (field 13).
   *
   * Currently-accepted target distance in yards. Snapshotted onto the
   * participant row at bet accept, cleared back to 0 once the bet leaves
   * the active-target state. 0 also implies has_accepted_bet=false.
   *
   * @generated from field: int64 target_distance_yards = 8;
   */
  targetDistanceYards: bigint;

  /**
   * Most-recent-fill preview, overwrite-only — set on bet_filled_partner,
   * overwritten on the next fill, NOT cleared on accept/cancel/expire.
   * The "current" displayable target when has_accepted_bet=false.
   *
   * @generated from field: int64 previewed_target_distance_yards = 9;
   */
  previewedTargetDistanceYards: bigint;

  /**
   * Predicted target for the SHOT AFTER the previewed bet, sourced from
   * Paylines' next_shot_target_yards at fill time. Same lifecycle as
   * previewed_target_distance_yards.
   *
   * @generated from field: int64 previewed_next_target_yards = 10;
   */
  previewedNextTargetYards: bigint;

  /**
   * Distance of the participant's previously-resolved bet. Set when
   * bet_resolved_partner fires, atomically alongside clearing
   * target_distance_yards. The [previous, current, next] window slides
   * forward on each resolution.
   *
   * @generated from field: int64 previous_target_distance_yards = 11;
   */
  previousTargetDistanceYards: bigint;

  /**
   * Outcome of the previously-resolved bet (WON / LOST / CANCELLED /
   * EXPIRED). UNSPECIFIED (0) when no previous bet exists yet. Drives
   * the previous-row color hint in the round-robin UI.
   *
   * @generated from field: qb.smg.BetOutcome previous_target_outcome = 12;
   */
  previousTargetOutcome: BetOutcome;

  /**
   * True iff the streaming player has currently accepted a bet. Disambig-
   * uates target_distance_yards (canonical when true) from
   * previewed_target_distance_yards (canonical when false). Mirrors
   * FullSwingSessionParticipant.has_accepted_bet for this user.
   *
   * @generated from field: bool has_accepted_bet = 13;
   */
  hasAcceptedBet: boolean;

  /**
   * Current session play mode — surfaced on the kiosk stream so mobile
   * clients can dim controls in SOLO and suppress practice-mode UI when
   * only one player is present. The participant-stream payload already
   * carries the same value (FullSwingSessionParticipationDetailsStreamUpdate.
   * play_mode); this field is the kiosk equivalent so mobile does not
   * need to open a second subscription. Pre-deploy servers leave this
   * unset and the proto3 default-zero (SESSION_PLAY_MODE_UNKNOWN) is
   * treated as "not SOLO" by mobile (no behavioural change for older
   * builds).
   *
   * @generated from field: qb.smg.SessionPlayMode play_mode = 14;
   */
  playMode: SessionPlayMode;

  /**
   * Full session roster, mapped from the same participant snapshot the
   * handler already fetches once per emit. Populated on EVERY
   * UserSessionUpdate (initial and every subsequent re-emit, including the
   * turn-advance re-emit), so the kiosk always holds the complete
   * {user_id, username, is_active} list without opening a second
   * subscription to the simulator-token-gated participant-details stream.
   * Empty only when the per-emit roster fetch transiently failed (graceful
   * degradation — the rest of the update message stays valid). Pre-deploy
   * servers leave this unset and the proto3 default (empty repeated) is a
   * no-op for older clients.
   *
   * @generated from field: repeated qb.smg.KioskParticipant participants = 15;
   */
  participants: KioskParticipant[];
};

/**
 * Describes the message qb.smg.PartnerKioskUpdate.UserSessionUpdateData.
 * Use `create(PartnerKioskUpdate_UserSessionUpdateDataSchema)` to create a new message.
 */
export const PartnerKioskUpdate_UserSessionUpdateDataSchema: GenMessage<PartnerKioskUpdate_UserSessionUpdateData> = /*@__PURE__*/
  messageDesc(file_partner_service, 29, 2);

/**
 * @generated from enum qb.smg.PartnerKioskUpdate.UserSessionUpdateData.UserSessionState
 */
export enum PartnerKioskUpdate_UserSessionUpdateData_UserSessionState {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * not in the list
   *
   * @generated from enum value: NOT_JOINED = 1;
   */
  NOT_JOINED = 1,

  /**
   * in list, but not playing
   *
   * @generated from enum value: NOT_ACTIVE = 2;
   */
  NOT_ACTIVE = 2,

  /**
   * in list, playing
   *
   * @generated from enum value: ACTIVE = 3;
   */
  ACTIVE = 3,
}

/**
 * Describes the enum qb.smg.PartnerKioskUpdate.UserSessionUpdateData.UserSessionState.
 */
export const PartnerKioskUpdate_UserSessionUpdateData_UserSessionStateSchema: GenEnum<PartnerKioskUpdate_UserSessionUpdateData_UserSessionState> = /*@__PURE__*/
  enumDesc(file_partner_service, 29, 2, 0);

/**
 * @generated from enum qb.smg.PartnerKioskUpdate.UpdateKind
 */
export enum PartnerKioskUpdate_UpdateKind {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: INIT = 1;
   */
  INIT = 1,

  /**
   * @generated from enum value: HEART_BEAT = 2;
   */
  HEART_BEAT = 2,

  /**
   * @generated from enum value: USER_SESSION_PARTICIPATION_CONFIRMATION = 3;
   */
  USER_SESSION_PARTICIPATION_CONFIRMATION = 3,

  /**
   * @generated from enum value: USER_SESSION_UPDATE = 4;
   */
  USER_SESSION_UPDATE = 4,

  /**
   * @generated from enum value: USER_SESSION_PENDING_CONFIRMATION_REMOVAL = 5;
   */
  USER_SESSION_PENDING_CONFIRMATION_REMOVAL = 5,
}

/**
 * Describes the enum qb.smg.PartnerKioskUpdate.UpdateKind.
 */
export const PartnerKioskUpdate_UpdateKindSchema: GenEnum<PartnerKioskUpdate_UpdateKind> = /*@__PURE__*/
  enumDesc(file_partner_service, 29, 0);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationConfirmationRespondRequest
 */
export type FullSwingSessionParticipationConfirmationRespondRequest = Message<"qb.smg.FullSwingSessionParticipationConfirmationRespondRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * either user accepted confirmation or not
   *
   * @generated from field: bool accepted = 2;
   */
  accepted: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationConfirmationRespondRequest.
 * Use `create(FullSwingSessionParticipationConfirmationRespondRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationConfirmationRespondRequestSchema: GenMessage<FullSwingSessionParticipationConfirmationRespondRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 30);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationConfirmationRespondReply
 */
export type FullSwingSessionParticipationConfirmationRespondReply = Message<"qb.smg.FullSwingSessionParticipationConfirmationRespondReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationConfirmationRespondReply.
 * Use `create(FullSwingSessionParticipationConfirmationRespondReplySchema)` to create a new message.
 */
export const FullSwingSessionParticipationConfirmationRespondReplySchema: GenMessage<FullSwingSessionParticipationConfirmationRespondReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 31);

/**
 * @generated from message qb.smg.FullSwingLoginCheckInRequest
 */
export type FullSwingLoginCheckInRequest = Message<"qb.smg.FullSwingLoginCheckInRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The session user checks-in
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * When true, skip mobile device confirmation for this session (player-level preference)
   *
   * @generated from field: bool bypass_confirmation = 3;
   */
  bypassConfirmation: boolean;
};

/**
 * Describes the message qb.smg.FullSwingLoginCheckInRequest.
 * Use `create(FullSwingLoginCheckInRequestSchema)` to create a new message.
 */
export const FullSwingLoginCheckInRequestSchema: GenMessage<FullSwingLoginCheckInRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 32);

/**
 * @generated from message qb.smg.FullSwingLoginCheckInReply
 */
export type FullSwingLoginCheckInReply = Message<"qb.smg.FullSwingLoginCheckInReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingLoginCheckInReply.
 * Use `create(FullSwingLoginCheckInReplySchema)` to create a new message.
 */
export const FullSwingLoginCheckInReplySchema: GenMessage<FullSwingLoginCheckInReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 33);

/**
 * @generated from message qb.smg.FullSwingLoginCheckOutRequest
 */
export type FullSwingLoginCheckOutRequest = Message<"qb.smg.FullSwingLoginCheckOutRequest"> & {
  /**
   * The user session token used for authentication.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * The session user checks-out
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingLoginCheckOutRequest.
 * Use `create(FullSwingLoginCheckOutRequestSchema)` to create a new message.
 */
export const FullSwingLoginCheckOutRequestSchema: GenMessage<FullSwingLoginCheckOutRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 34);

/**
 * @generated from message qb.smg.FullSwingLoginCheckOutReply
 */
export type FullSwingLoginCheckOutReply = Message<"qb.smg.FullSwingLoginCheckOutReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * If players successfully activated on the given station
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingLoginCheckOutReply.
 * Use `create(FullSwingLoginCheckOutReplySchema)` to create a new message.
 */
export const FullSwingLoginCheckOutReplySchema: GenMessage<FullSwingLoginCheckOutReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 35);

/**
 * @generated from message qb.smg.FullSwingSendWelcomeEmailRequest
 */
export type FullSwingSendWelcomeEmailRequest = Message<"qb.smg.FullSwingSendWelcomeEmailRequest"> & {
  /**
   * The user token used for authentication.
   *
   * @generated from field: string id_token = 1;
   */
  idToken: string;
};

/**
 * Describes the message qb.smg.FullSwingSendWelcomeEmailRequest.
 * Use `create(FullSwingSendWelcomeEmailRequestSchema)` to create a new message.
 */
export const FullSwingSendWelcomeEmailRequestSchema: GenMessage<FullSwingSendWelcomeEmailRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 36);

/**
 * @generated from message qb.smg.FullSwingSendWelcomeEmailReply
 */
export type FullSwingSendWelcomeEmailReply = Message<"qb.smg.FullSwingSendWelcomeEmailReply"> & {
  /**
   * Error details if the operation failed, null if successful.
   *
   * @generated from field: qb.smg.Error error = 1;
   */
  error?: Error;

  /**
   * Indicates whether the request was successful.
   *
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message qb.smg.FullSwingSendWelcomeEmailReply.
 * Use `create(FullSwingSendWelcomeEmailReplySchema)` to create a new message.
 */
export const FullSwingSendWelcomeEmailReplySchema: GenMessage<FullSwingSendWelcomeEmailReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 37);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationConfirmationDisplayedRequest
 */
export type FullSwingSessionParticipationConfirmationDisplayedRequest = Message<"qb.smg.FullSwingSessionParticipationConfirmationDisplayedRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationConfirmationDisplayedRequest.
 * Use `create(FullSwingSessionParticipationConfirmationDisplayedRequestSchema)` to create a new message.
 */
export const FullSwingSessionParticipationConfirmationDisplayedRequestSchema: GenMessage<FullSwingSessionParticipationConfirmationDisplayedRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 38);

/**
 * @generated from message qb.smg.FullSwingSessionParticipationConfirmationDisplayedReply
 */
export type FullSwingSessionParticipationConfirmationDisplayedReply = Message<"qb.smg.FullSwingSessionParticipationConfirmationDisplayedReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSessionParticipationConfirmationDisplayedReply.
 * Use `create(FullSwingSessionParticipationConfirmationDisplayedReplySchema)` to create a new message.
 */
export const FullSwingSessionParticipationConfirmationDisplayedReplySchema: GenMessage<FullSwingSessionParticipationConfirmationDisplayedReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 39);

/**
 * @generated from message qb.smg.EnableConfirmationBypassRequest
 */
export type EnableConfirmationBypassRequest = Message<"qb.smg.EnableConfirmationBypassRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.EnableConfirmationBypassRequest.
 * Use `create(EnableConfirmationBypassRequestSchema)` to create a new message.
 */
export const EnableConfirmationBypassRequestSchema: GenMessage<EnableConfirmationBypassRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 40);

/**
 * @generated from message qb.smg.DisableConfirmationBypassRequest
 */
export type DisableConfirmationBypassRequest = Message<"qb.smg.DisableConfirmationBypassRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.DisableConfirmationBypassRequest.
 * Use `create(DisableConfirmationBypassRequestSchema)` to create a new message.
 */
export const DisableConfirmationBypassRequestSchema: GenMessage<DisableConfirmationBypassRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 41);

/**
 * @generated from message qb.smg.GetConfirmationBypassStatusRequest
 */
export type GetConfirmationBypassStatusRequest = Message<"qb.smg.GetConfirmationBypassStatusRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message qb.smg.GetConfirmationBypassStatusRequest.
 * Use `create(GetConfirmationBypassStatusRequestSchema)` to create a new message.
 */
export const GetConfirmationBypassStatusRequestSchema: GenMessage<GetConfirmationBypassStatusRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 42);

/**
 * @generated from message qb.smg.ConfirmationBypassResponse
 */
export type ConfirmationBypassResponse = Message<"qb.smg.ConfirmationBypassResponse"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;
};

/**
 * Describes the message qb.smg.ConfirmationBypassResponse.
 * Use `create(ConfirmationBypassResponseSchema)` to create a new message.
 */
export const ConfirmationBypassResponseSchema: GenMessage<ConfirmationBypassResponse> = /*@__PURE__*/
  messageDesc(file_partner_service, 43);

/**
 * @generated from message qb.smg.FullSwingSessionUpdateRoundRobinRequest
 */
export type FullSwingSessionUpdateRoundRobinRequest = Message<"qb.smg.FullSwingSessionUpdateRoundRobinRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * must be > 0
   *
   * @generated from field: int32 shots_per_turn = 3;
   */
  shotsPerTurn: number;

  /**
   * optional: if set, triggers a stream update to connected clients
   *
   * @generated from field: string session_id = 4;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingSessionUpdateRoundRobinRequest.
 * Use `create(FullSwingSessionUpdateRoundRobinRequestSchema)` to create a new message.
 */
export const FullSwingSessionUpdateRoundRobinRequestSchema: GenMessage<FullSwingSessionUpdateRoundRobinRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 44);

/**
 * @generated from message qb.smg.FullSwingSessionUpdateRoundRobinReply
 */
export type FullSwingSessionUpdateRoundRobinReply = Message<"qb.smg.FullSwingSessionUpdateRoundRobinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSessionUpdateRoundRobinReply.
 * Use `create(FullSwingSessionUpdateRoundRobinReplySchema)` to create a new message.
 */
export const FullSwingSessionUpdateRoundRobinReplySchema: GenMessage<FullSwingSessionUpdateRoundRobinReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 45);

/**
 * @generated from message qb.smg.FullSwingSessionSkipToNextPlayerRequest
 */
export type FullSwingSessionSkipToNextPlayerRequest = Message<"qb.smg.FullSwingSessionSkipToNextPlayerRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * used to publish stream update
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingSessionSkipToNextPlayerRequest.
 * Use `create(FullSwingSessionSkipToNextPlayerRequestSchema)` to create a new message.
 */
export const FullSwingSessionSkipToNextPlayerRequestSchema: GenMessage<FullSwingSessionSkipToNextPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 46);

/**
 * @generated from message qb.smg.FullSwingSessionSkipToNextPlayerReply
 */
export type FullSwingSessionSkipToNextPlayerReply = Message<"qb.smg.FullSwingSessionSkipToNextPlayerReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSessionSkipToNextPlayerReply.
 * Use `create(FullSwingSessionSkipToNextPlayerReplySchema)` to create a new message.
 */
export const FullSwingSessionSkipToNextPlayerReplySchema: GenMessage<FullSwingSessionSkipToNextPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 47);

/**
 * @generated from message qb.smg.FullSwingSessionSkipToPlayerRequest
 */
export type FullSwingSessionSkipToPlayerRequest = Message<"qb.smg.FullSwingSessionSkipToPlayerRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: int64 station_id = 2;
   */
  stationId: bigint;

  /**
   * the user to skip TO
   *
   * @generated from field: int64 user_id = 3;
   */
  userId: bigint;

  /**
   * used to publish stream update
   *
   * @generated from field: string session_id = 4;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.FullSwingSessionSkipToPlayerRequest.
 * Use `create(FullSwingSessionSkipToPlayerRequestSchema)` to create a new message.
 */
export const FullSwingSessionSkipToPlayerRequestSchema: GenMessage<FullSwingSessionSkipToPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 48);

/**
 * @generated from message qb.smg.FullSwingSessionSkipToPlayerReply
 */
export type FullSwingSessionSkipToPlayerReply = Message<"qb.smg.FullSwingSessionSkipToPlayerReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSessionSkipToPlayerReply.
 * Use `create(FullSwingSessionSkipToPlayerReplySchema)` to create a new message.
 */
export const FullSwingSessionSkipToPlayerReplySchema: GenMessage<FullSwingSessionSkipToPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 49);

/**
 * @generated from message qb.smg.KioskSkipMyNextTurnRequest
 */
export type KioskSkipMyNextTurnRequest = Message<"qb.smg.KioskSkipMyNextTurnRequest"> & {
  /**
   * kiosk user session token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * the session to skip in
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;
};

/**
 * Describes the message qb.smg.KioskSkipMyNextTurnRequest.
 * Use `create(KioskSkipMyNextTurnRequestSchema)` to create a new message.
 */
export const KioskSkipMyNextTurnRequestSchema: GenMessage<KioskSkipMyNextTurnRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 50);

/**
 * @generated from message qb.smg.KioskSkipMyNextTurnReply
 */
export type KioskSkipMyNextTurnReply = Message<"qb.smg.KioskSkipMyNextTurnReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.KioskSkipMyNextTurnReply.
 * Use `create(KioskSkipMyNextTurnReplySchema)` to create a new message.
 */
export const KioskSkipMyNextTurnReplySchema: GenMessage<KioskSkipMyNextTurnReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 51);

/**
 * @generated from message qb.smg.FullSwingSetPlayerBypassConfirmationRequest
 */
export type FullSwingSetPlayerBypassConfirmationRequest = Message<"qb.smg.FullSwingSetPlayerBypassConfirmationRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * true to bypass confirmation, false to require it
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * simulator token — required; the RPC mutates per-player
   *
   * @generated from field: string token = 4;
   */
  token: string;
};

/**
 * Describes the message qb.smg.FullSwingSetPlayerBypassConfirmationRequest.
 * Use `create(FullSwingSetPlayerBypassConfirmationRequestSchema)` to create a new message.
 */
export const FullSwingSetPlayerBypassConfirmationRequestSchema: GenMessage<FullSwingSetPlayerBypassConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 52);

/**
 * @generated from message qb.smg.FullSwingSetPlayerBypassConfirmationReply
 */
export type FullSwingSetPlayerBypassConfirmationReply = Message<"qb.smg.FullSwingSetPlayerBypassConfirmationReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSetPlayerBypassConfirmationReply.
 * Use `create(FullSwingSetPlayerBypassConfirmationReplySchema)` to create a new message.
 */
export const FullSwingSetPlayerBypassConfirmationReplySchema: GenMessage<FullSwingSetPlayerBypassConfirmationReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 53);

/**
 * @generated from message qb.smg.FullSwingEnableRoundRobinRequest
 */
export type FullSwingEnableRoundRobinRequest = Message<"qb.smg.FullSwingEnableRoundRobinRequest"> & {
  /**
   * simulator token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * must be in [1, 20]
   *
   * @generated from field: int32 shots_per_player = 4;
   */
  shotsPerPlayer: number;

  /**
   * 0 = no turn timeout
   *
   * @generated from field: int32 timeout_seconds = 5;
   */
  timeoutSeconds: number;
};

/**
 * Describes the message qb.smg.FullSwingEnableRoundRobinRequest.
 * Use `create(FullSwingEnableRoundRobinRequestSchema)` to create a new message.
 */
export const FullSwingEnableRoundRobinRequestSchema: GenMessage<FullSwingEnableRoundRobinRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 54);

/**
 * @generated from message qb.smg.FullSwingEnableRoundRobinReply
 */
export type FullSwingEnableRoundRobinReply = Message<"qb.smg.FullSwingEnableRoundRobinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingEnableRoundRobinReply.
 * Use `create(FullSwingEnableRoundRobinReplySchema)` to create a new message.
 */
export const FullSwingEnableRoundRobinReplySchema: GenMessage<FullSwingEnableRoundRobinReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 55);

/**
 * @generated from message qb.smg.FullSwingDisableRoundRobinRequest
 */
export type FullSwingDisableRoundRobinRequest = Message<"qb.smg.FullSwingDisableRoundRobinRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingDisableRoundRobinRequest.
 * Use `create(FullSwingDisableRoundRobinRequestSchema)` to create a new message.
 */
export const FullSwingDisableRoundRobinRequestSchema: GenMessage<FullSwingDisableRoundRobinRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 56);

/**
 * @generated from message qb.smg.FullSwingDisableRoundRobinReply
 */
export type FullSwingDisableRoundRobinReply = Message<"qb.smg.FullSwingDisableRoundRobinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingDisableRoundRobinReply.
 * Use `create(FullSwingDisableRoundRobinReplySchema)` to create a new message.
 */
export const FullSwingDisableRoundRobinReplySchema: GenMessage<FullSwingDisableRoundRobinReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 57);

/**
 * @generated from message qb.smg.FullSwingRoundRobinPlayerOrderEntry
 */
export type FullSwingRoundRobinPlayerOrderEntry = Message<"qb.smg.FullSwingRoundRobinPlayerOrderEntry"> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * 0 = use default
   *
   * @generated from field: int32 shots_per_player_override = 2;
   */
  shotsPerPlayerOverride: number;
};

/**
 * Describes the message qb.smg.FullSwingRoundRobinPlayerOrderEntry.
 * Use `create(FullSwingRoundRobinPlayerOrderEntrySchema)` to create a new message.
 */
export const FullSwingRoundRobinPlayerOrderEntrySchema: GenMessage<FullSwingRoundRobinPlayerOrderEntry> = /*@__PURE__*/
  messageDesc(file_partner_service, 58);

/**
 * @generated from message qb.smg.FullSwingSetRoundRobinOrderRequest
 */
export type FullSwingSetRoundRobinOrderRequest = Message<"qb.smg.FullSwingSetRoundRobinOrderRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: repeated qb.smg.FullSwingRoundRobinPlayerOrderEntry entries = 4;
   */
  entries: FullSwingRoundRobinPlayerOrderEntry[];
};

/**
 * Describes the message qb.smg.FullSwingSetRoundRobinOrderRequest.
 * Use `create(FullSwingSetRoundRobinOrderRequestSchema)` to create a new message.
 */
export const FullSwingSetRoundRobinOrderRequestSchema: GenMessage<FullSwingSetRoundRobinOrderRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 59);

/**
 * @generated from message qb.smg.FullSwingSetRoundRobinOrderReply
 */
export type FullSwingSetRoundRobinOrderReply = Message<"qb.smg.FullSwingSetRoundRobinOrderReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSetRoundRobinOrderReply.
 * Use `create(FullSwingSetRoundRobinOrderReplySchema)` to create a new message.
 */
export const FullSwingSetRoundRobinOrderReplySchema: GenMessage<FullSwingSetRoundRobinOrderReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 60);

/**
 * @generated from message qb.smg.FullSwingSkipToPlayerRequest
 */
export type FullSwingSkipToPlayerRequest = Message<"qb.smg.FullSwingSkipToPlayerRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * the user to skip TO
   *
   * @generated from field: int64 user_id = 4;
   */
  userId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSkipToPlayerRequest.
 * Use `create(FullSwingSkipToPlayerRequestSchema)` to create a new message.
 */
export const FullSwingSkipToPlayerRequestSchema: GenMessage<FullSwingSkipToPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 61);

/**
 * @generated from message qb.smg.FullSwingSkipToPlayerReply
 */
export type FullSwingSkipToPlayerReply = Message<"qb.smg.FullSwingSkipToPlayerReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSkipToPlayerReply.
 * Use `create(FullSwingSkipToPlayerReplySchema)` to create a new message.
 */
export const FullSwingSkipToPlayerReplySchema: GenMessage<FullSwingSkipToPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 62);

/**
 * @generated from message qb.smg.FullSwingSkipNextRoundRobinPlayerRequest
 */
export type FullSwingSkipNextRoundRobinPlayerRequest = Message<"qb.smg.FullSwingSkipNextRoundRobinPlayerRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingSkipNextRoundRobinPlayerRequest.
 * Use `create(FullSwingSkipNextRoundRobinPlayerRequestSchema)` to create a new message.
 */
export const FullSwingSkipNextRoundRobinPlayerRequestSchema: GenMessage<FullSwingSkipNextRoundRobinPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 63);

/**
 * @generated from message qb.smg.FullSwingSkipNextRoundRobinPlayerReply
 */
export type FullSwingSkipNextRoundRobinPlayerReply = Message<"qb.smg.FullSwingSkipNextRoundRobinPlayerReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingSkipNextRoundRobinPlayerReply.
 * Use `create(FullSwingSkipNextRoundRobinPlayerReplySchema)` to create a new message.
 */
export const FullSwingSkipNextRoundRobinPlayerReplySchema: GenMessage<FullSwingSkipNextRoundRobinPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 64);

/**
 * @generated from message qb.smg.FullSwingResetRoundRobinRequest
 */
export type FullSwingResetRoundRobinRequest = Message<"qb.smg.FullSwingResetRoundRobinRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingResetRoundRobinRequest.
 * Use `create(FullSwingResetRoundRobinRequestSchema)` to create a new message.
 */
export const FullSwingResetRoundRobinRequestSchema: GenMessage<FullSwingResetRoundRobinRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 65);

/**
 * @generated from message qb.smg.FullSwingResetRoundRobinReply
 */
export type FullSwingResetRoundRobinReply = Message<"qb.smg.FullSwingResetRoundRobinReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingResetRoundRobinReply.
 * Use `create(FullSwingResetRoundRobinReplySchema)` to create a new message.
 */
export const FullSwingResetRoundRobinReplySchema: GenMessage<FullSwingResetRoundRobinReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 66);

/**
 * @generated from message qb.smg.FullSwingRemoveRoundRobinPlayerRequest
 */
export type FullSwingRemoveRoundRobinPlayerRequest = Message<"qb.smg.FullSwingRemoveRoundRobinPlayerRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 user_id = 4;
   */
  userId: bigint;
};

/**
 * Describes the message qb.smg.FullSwingRemoveRoundRobinPlayerRequest.
 * Use `create(FullSwingRemoveRoundRobinPlayerRequestSchema)` to create a new message.
 */
export const FullSwingRemoveRoundRobinPlayerRequestSchema: GenMessage<FullSwingRemoveRoundRobinPlayerRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 67);

/**
 * @generated from message qb.smg.FullSwingRemoveRoundRobinPlayerReply
 */
export type FullSwingRemoveRoundRobinPlayerReply = Message<"qb.smg.FullSwingRemoveRoundRobinPlayerReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingRemoveRoundRobinPlayerReply.
 * Use `create(FullSwingRemoveRoundRobinPlayerReplySchema)` to create a new message.
 */
export const FullSwingRemoveRoundRobinPlayerReplySchema: GenMessage<FullSwingRemoveRoundRobinPlayerReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 68);

/**
 * @generated from message qb.smg.FullSwingUpdateRoundRobinConfirmationBypassRequest
 */
export type FullSwingUpdateRoundRobinConfirmationBypassRequest = Message<"qb.smg.FullSwingUpdateRoundRobinConfirmationBypassRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: int64 station_id = 3;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 user_id = 4;
   */
  userId: bigint;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;
};

/**
 * Describes the message qb.smg.FullSwingUpdateRoundRobinConfirmationBypassRequest.
 * Use `create(FullSwingUpdateRoundRobinConfirmationBypassRequestSchema)` to create a new message.
 */
export const FullSwingUpdateRoundRobinConfirmationBypassRequestSchema: GenMessage<FullSwingUpdateRoundRobinConfirmationBypassRequest> = /*@__PURE__*/
  messageDesc(file_partner_service, 69);

/**
 * @generated from message qb.smg.FullSwingUpdateRoundRobinConfirmationBypassReply
 */
export type FullSwingUpdateRoundRobinConfirmationBypassReply = Message<"qb.smg.FullSwingUpdateRoundRobinConfirmationBypassReply"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: qb.smg.Error error = 2;
   */
  error?: Error;
};

/**
 * Describes the message qb.smg.FullSwingUpdateRoundRobinConfirmationBypassReply.
 * Use `create(FullSwingUpdateRoundRobinConfirmationBypassReplySchema)` to create a new message.
 */
export const FullSwingUpdateRoundRobinConfirmationBypassReplySchema: GenMessage<FullSwingUpdateRoundRobinConfirmationBypassReply> = /*@__PURE__*/
  messageDesc(file_partner_service, 70);

/**
 * @generated from enum qb.smg.SimulatorMoneyCapability
 */
export enum SimulatorMoneyCapability {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: REAL_MONEY = 1;
   */
  REAL_MONEY = 1,

  /**
   * @generated from enum value: UNSUPPORTED = 2;
   */
  UNSUPPORTED = 2,
}

/**
 * Describes the enum qb.smg.SimulatorMoneyCapability.
 */
export const SimulatorMoneyCapabilitySchema: GenEnum<SimulatorMoneyCapability> = /*@__PURE__*/
  enumDesc(file_partner_service, 0);

/**
 * SessionPlayMode describes how turns are managed at a station session.
 *
 * @generated from enum qb.smg.SessionPlayMode
 */
export enum SessionPlayMode {
  /**
   * @generated from enum value: SESSION_PLAY_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_SOLO = 1;
   */
  SOLO = 1,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_ROTATION = 3;
   */
  ROTATION = 3,
}

/**
 * Describes the enum qb.smg.SessionPlayMode.
 */
export const SessionPlayModeSchema: GenEnum<SessionPlayMode> = /*@__PURE__*/
  enumDesc(file_partner_service, 1);

/**
 * BetOutcome enumerates the terminal states of a bet. Used by the
 * round-robin UI to color the participant's previous-shot slot
 * (WON=green, LOST=red, CANCELLED/EXPIRED=neutral). The 0 default
 * means "no previous bet yet" — the slot is empty.
 *
 * @generated from enum qb.smg.BetOutcome
 */
export enum BetOutcome {
  /**
   * @generated from enum value: BET_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_OUTCOME_WON = 1;
   */
  WON = 1,

  /**
   * @generated from enum value: BET_OUTCOME_LOST = 2;
   */
  LOST = 2,

  /**
   * @generated from enum value: BET_OUTCOME_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: BET_OUTCOME_EXPIRED = 4;
   */
  EXPIRED = 4,
}

/**
 * Describes the enum qb.smg.BetOutcome.
 */
export const BetOutcomeSchema: GenEnum<BetOutcome> = /*@__PURE__*/
  enumDesc(file_partner_service, 2);

/**
 * *
 * The Partner Service provides methods for simulating user interactions with stations.
 * This service allows partners to authenticate users and make them active players at specific stations.
 *
 * @generated from service qb.smg.PartnerService
 */
export const PartnerService: GenService<{
  /**
   * *
   * SimulateUserTemporary authenticates a user with the provided session token
   * and makes them the active player at the specified station.
   *
   * @generated from rpc qb.smg.PartnerService.SimulateUserTemporary
   */
  simulateUserTemporary: {
    methodKind: "unary";
    input: typeof SimulateUserTemporaryRequestSchema;
    output: typeof SimulateUserTemporaryReplySchema;
  },
  /**
   * *
   * SimulateUserViaBluetooth authenticates a user with the provided session token
   * and makes them the active player at the station identified by the Bluetooth service UUID.
   *
   * @generated from rpc qb.smg.PartnerService.SimulateUserViaBluetooth
   */
  simulateUserViaBluetooth: {
    methodKind: "unary";
    input: typeof SimulateUserViaBluetoothRequestSchema;
    output: typeof SimulateUserViaBluetoothReplySchema;
  },
  /**
   * *
   * SimulateUserViaQrCode authenticates a user with the provided session token
   * and makes them the active player at the station identified by the QR code.
   *
   * @generated from rpc qb.smg.PartnerService.SimulateUserViaQrCode
   */
  simulateUserViaQrCode: {
    methodKind: "unary";
    input: typeof SimulateUserViaQrCodeRequestSchema;
    output: typeof SimulateUserViaQrCodeReplySchema;
  },
  /**
   * *
   * Special login method for FullSwing partner, which will create new user and/or login that user.
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingTokenLogin
   */
  fullSwingTokenLogin: {
    methodKind: "unary";
    input: typeof FullSwingTokenLoginRequestSchema;
    output: typeof FullSwingTokenLoginReplySchema;
  },
  /**
   * *
   * Special method for cancelling user registration.
   * This method will work before Terms&Conditions page passed, after that user is considered fully registered and register cancellation is no longer possible
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingCancelRegister
   */
  fullSwingCancelRegister: {
    methodKind: "unary";
    input: typeof FullSwingCancelRegisterRequestSchema;
    output: typeof FullSwingCancelRegisterReplySchema;
  },
  /**
   * *
   * Special login method for FullSwing partner, which will create new user and/or login that user.
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingCheckSimulatorIdentifier
   */
  fullSwingCheckSimulatorIdentifier: {
    methodKind: "unary";
    input: typeof FullSwingCheckSimulatorIdentifierRequestSchema;
    output: typeof FullSwingCheckSimulatorIdentifierReplySchema;
  },
  /**
   * *
   * GetSimulatorDeviceLocation returns the RAW partner-supplied location for a
   * simulator device (lat/long + postal address), as the FullSwing geo source
   * reports it — pre-normalization. Unlike FullSwingCheckSimulatorIdentifier,
   * which returns only a money-capability VERDICT, this RPC returns the address
   * itself so core's capability-resolution pipeline (SMG-3174) can derive a
   * jurisdiction. An unknown / unparseable identifier is NOT an error: the
   * reply carries valid=false with empty location fields, and core degrades to
   * "jurisdiction unresolved" (gated capabilities fail closed). The FullSwing
   * API credentials + OAuth/JWKS stack stay on partner-service; core only CALLs
   * this RPC.
   *
   * @generated from rpc qb.smg.PartnerService.GetSimulatorDeviceLocation
   */
  getSimulatorDeviceLocation: {
    methodKind: "unary";
    input: typeof GetSimulatorDeviceLocationRequestSchema;
    output: typeof GetSimulatorDeviceLocationReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationDetailsStream
   */
  fullSwingSessionParticipationDetailsStream: {
    methodKind: "server_streaming";
    input: typeof FullSwingSessionParticipationDetailsStreamRequestSchema;
    output: typeof FullSwingSessionParticipationDetailsStreamUpdateSchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionConfigure
   */
  fullSwingSessionConfigure: {
    methodKind: "unary";
    input: typeof FullSwingSessionConfigureRequestSchema;
    output: typeof FullSwingSessionConfigureReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationRemovePlayer
   */
  fullSwingSessionParticipationRemovePlayer: {
    methodKind: "unary";
    input: typeof FullSwingSessionParticipationRemovePlayerRequestSchema;
    output: typeof FullSwingSessionParticipationRemovePlayerReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationSelectPlayer
   */
  fullSwingSessionParticipationSelectPlayer: {
    methodKind: "unary";
    input: typeof FullSwingSessionParticipationSelectPlayerRequestSchema;
    output: typeof FullSwingSessionParticipationSelectPlayerReplySchema;
  },
  /**
   * get and respond confirmation updates
   * Simulator => Server => Kiosk (Pending Confirmation). Accept / Decline (after 1 minutes passed disappear)
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationConfirmationRespond
   */
  fullSwingSessionParticipationConfirmationRespond: {
    methodKind: "unary";
    input: typeof FullSwingSessionParticipationConfirmationRespondRequestSchema;
    output: typeof FullSwingSessionParticipationConfirmationRespondReplySchema;
  },
  /**
   * receive updates for partner kiosk updates
   *
   * @generated from rpc qb.smg.PartnerService.PartnerKioskUpdatesStream
   */
  partnerKioskUpdatesStream: {
    methodKind: "server_streaming";
    input: typeof PartnerKioskUpdatesStreamRequestSchema;
    output: typeof PartnerKioskUpdateSchema;
  },
  /**
   * should be called after login/register before showing home page
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingCheckIn
   */
  fullSwingCheckIn: {
    methodKind: "unary";
    input: typeof FullSwingLoginCheckInRequestSchema;
    output: typeof FullSwingLoginCheckInReplySchema;
  },
  /**
   * should be called before logout
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingCheckOut
   */
  fullSwingCheckOut: {
    methodKind: "unary";
    input: typeof FullSwingLoginCheckOutRequestSchema;
    output: typeof FullSwingLoginCheckOutReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSendWelcomeEmail
   */
  fullSwingSendWelcomeEmail: {
    methodKind: "unary";
    input: typeof FullSwingSendWelcomeEmailRequestSchema;
    output: typeof FullSwingSendWelcomeEmailReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationDeactivation
   */
  fullSwingSessionParticipationDeactivation: {
    methodKind: "unary";
    input: typeof FullSwingSessionParticipationDeactivationRequestSchema;
    output: typeof FullSwingSessionParticipationDeactivationReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionParticipationConfirmationDisplayed
   */
  fullSwingSessionParticipationConfirmationDisplayed: {
    methodKind: "unary";
    input: typeof FullSwingSessionParticipationConfirmationDisplayedRequestSchema;
    output: typeof FullSwingSessionParticipationConfirmationDisplayedReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.EnableConfirmationBypass
   */
  enableConfirmationBypass: {
    methodKind: "unary";
    input: typeof EnableConfirmationBypassRequestSchema;
    output: typeof ConfirmationBypassResponseSchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.DisableConfirmationBypass
   */
  disableConfirmationBypass: {
    methodKind: "unary";
    input: typeof DisableConfirmationBypassRequestSchema;
    output: typeof ConfirmationBypassResponseSchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.GetConfirmationBypassStatus
   */
  getConfirmationBypassStatus: {
    methodKind: "unary";
    input: typeof GetConfirmationBypassStatusRequestSchema;
    output: typeof ConfirmationBypassResponseSchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionUpdateRoundRobin
   */
  fullSwingSessionUpdateRoundRobin: {
    methodKind: "unary";
    input: typeof FullSwingSessionUpdateRoundRobinRequestSchema;
    output: typeof FullSwingSessionUpdateRoundRobinReplySchema;
  },
  /**
   * Round-robin skip RPCs — authenticated with simulator token, proxied to StationStateComputer.
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionSkipToNextPlayer
   */
  fullSwingSessionSkipToNextPlayer: {
    methodKind: "unary";
    input: typeof FullSwingSessionSkipToNextPlayerRequestSchema;
    output: typeof FullSwingSessionSkipToNextPlayerReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSessionSkipToPlayer
   */
  fullSwingSessionSkipToPlayer: {
    methodKind: "unary";
    input: typeof FullSwingSessionSkipToPlayerRequestSchema;
    output: typeof FullSwingSessionSkipToPlayerReplySchema;
  },
  /**
   * Toggle whether a player must confirm their identity on their mobile device.
   * Can be called by the kiosk or simulator at any point during the session.
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingSetPlayerBypassConfirmation
   */
  fullSwingSetPlayerBypassConfirmation: {
    methodKind: "unary";
    input: typeof FullSwingSetPlayerBypassConfirmationRequestSchema;
    output: typeof FullSwingSetPlayerBypassConfirmationReplySchema;
  },
  /**
   * KioskSkipMyNextTurn allows a kiosk user to opt out of their next turn in
   * round-robin rotation. The caller is identified by their session token; the
   * skip applies to their NEXT scheduled turn, not their currently active turn.
   *
   * @generated from rpc qb.smg.PartnerService.KioskSkipMyNextTurn
   */
  kioskSkipMyNextTurn: {
    methodKind: "unary";
    input: typeof KioskSkipMyNextTurnRequestSchema;
    output: typeof KioskSkipMyNextTurnReplySchema;
  },
  /**
   * -----------------------------------------------------------------------
   * Round-Robin orchestration (SMG-2463).
   *
   * These RPCs are the single external entry point for round-robin mutations.
   * Each one wraps a per-station orchestration lock and a single composition:
   *
   *   1. Mutate round-robin state in StationStateComputer.
   *   2. If the active (current) player changed as a result, activate the
   *      new participant in the partner-service session (DB IsActive flip +
   *      SSC ActiveUserId sync via SetActiveUser / ClearActiveUser, post
   *      SMG-2471 split of the old UpdateIgnoreFrsModeEnabled RPC).
   *   3. Emit a session update so FullSwing participant stream consumers see
   *      the change atomically with the SSC mutation.
   *
   * Simulators MUST use these RPCs rather than calling StationStateComputer
   * directly — direct simulator access to SSC is being phased out.
   *
   * The orchestration lock also serializes with the round-robin shot consumer
   * so simulator-initiated changes cannot race against turn-complete activation.
   * -----------------------------------------------------------------------
   *
   * @generated from rpc qb.smg.PartnerService.FullSwingEnableRoundRobin
   */
  fullSwingEnableRoundRobin: {
    methodKind: "unary";
    input: typeof FullSwingEnableRoundRobinRequestSchema;
    output: typeof FullSwingEnableRoundRobinReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingDisableRoundRobin
   */
  fullSwingDisableRoundRobin: {
    methodKind: "unary";
    input: typeof FullSwingDisableRoundRobinRequestSchema;
    output: typeof FullSwingDisableRoundRobinReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSetRoundRobinOrder
   */
  fullSwingSetRoundRobinOrder: {
    methodKind: "unary";
    input: typeof FullSwingSetRoundRobinOrderRequestSchema;
    output: typeof FullSwingSetRoundRobinOrderReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSkipToPlayer
   */
  fullSwingSkipToPlayer: {
    methodKind: "unary";
    input: typeof FullSwingSkipToPlayerRequestSchema;
    output: typeof FullSwingSkipToPlayerReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingSkipNextRoundRobinPlayer
   */
  fullSwingSkipNextRoundRobinPlayer: {
    methodKind: "unary";
    input: typeof FullSwingSkipNextRoundRobinPlayerRequestSchema;
    output: typeof FullSwingSkipNextRoundRobinPlayerReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingResetRoundRobin
   */
  fullSwingResetRoundRobin: {
    methodKind: "unary";
    input: typeof FullSwingResetRoundRobinRequestSchema;
    output: typeof FullSwingResetRoundRobinReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingRemoveRoundRobinPlayer
   */
  fullSwingRemoveRoundRobinPlayer: {
    methodKind: "unary";
    input: typeof FullSwingRemoveRoundRobinPlayerRequestSchema;
    output: typeof FullSwingRemoveRoundRobinPlayerReplySchema;
  },
  /**
   * @generated from rpc qb.smg.PartnerService.FullSwingUpdateRoundRobinConfirmationBypass
   */
  fullSwingUpdateRoundRobinConfirmationBypass: {
    methodKind: "unary";
    input: typeof FullSwingUpdateRoundRobinConfirmationBypassRequestSchema;
    output: typeof FullSwingUpdateRoundRobinConfirmationBypassReplySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_partner_service, 0);

